<div class="modal-header justify-content-end">
  <button
    type="button"
    class="close btn btn-outline-secondary"
    aria-label="Close"
    (click)="activeModal.dismiss('Cross click')"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <form class="text-center" (ngSubmit)="createNewUser()">
    <i class="fa fa-pied-piper-pp mb-2 mt-2" id="addUserLogo"></i>
    <h1 class="h3 mb-3 fw-normal">Add User</h1>

    <div class="input-group mb-3">
      <span class="input-group-text"
        ><i class="fa fa-user-circle" style="font-size: 1.5rem"></i
      ></span>
      <div class="form-floating flex-grow-1">
        <input
          [(ngModel)]="newUser.username"
          #username="ngModel"
          name="username"
          type="text"
          class="form-control"
          id="username"
          placeholder="Username"
          required
        />
        <label for="floatingInput">Username</label>
      </div>
    </div>
    <div class="form-floating mb-3">
      <input
        [(ngModel)]="newUser.firstName"
        #firstName="ngModel"
        name="firstName"
        type="text"
        class="form-control"
        id="firstName"
        placeholder="First Name"
        required
      />
      <label for="floatingInput">First Name</label>
    </div>
    <div class="form-floating mb-3">
      <input
        [(ngModel)]="newUser.lastName"
        #lastName="ngModel"
        name="lastName"
        type="text"
        class="form-control"
        id="lastName"
        placeholder="Last Name"
        required
      />
      <label for="floatingInput">Last Name</label>
    </div>
    <button
      [disabled]="username.invalid || firstName.invalid || lastName.invalid"
      class="btn btn-lg btn-secondary"
      type="submit"
    >
      Add User
    </button>
  </form>
</div>
